import React, { useEffect, useState } from "react";
import { Button, Box } from "@mui/material";
import api from "../../api/api";

const AddButton = ({ moduleKey, onAddClick }) => {
  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Дефолтные настройки для разных модулей
  const defaultActions = {
    employees: { label: "Добавить сотрудника", icon: "add" },
    staff: { label: "Добавить сотрудника", icon: "add" },
    clients: { label: "Добавить клиента", icon: "add" },
    assets: { label: "Добавить актив", icon: "add" },
    rental_deals: { label: "Добавить сделку", icon: "add" },
    rental_points: { label: "Добавить точку", icon: "add" },
    rental_tariffs: { label: "Добавить тариф", icon: "add" },
  };
  useEffect(() => {
    if (!moduleKey) {
      console.warn("moduleKey отсутствует");
      return;
    }

    // Если у нас есть дефолтное действие для этого модуля, не делаем запрос к API
    if (defaultActions[moduleKey]) {
      return;
    }

    // Только для неизвестных модулей пытаемся загрузить из API
    console.log(`Запрос к API: /actions?moduleKey=${moduleKey}`);
    const fetchActions = async () => {
      try {
        setLoading(true);
        setError(null);
        console.log("🚀 Отправляем запрос к API...");
        const response = await api.get(`/actions/`, {
          params: { moduleKey },
        });
        console.log("✅ Ответ от API:", response.data);
        setActions(response.data);
      } catch (err) {
        console.error("❌ Ошибка загрузки действий:", err);
        setError("Не удалось загрузить действия.");
        setActions([]); // Убеждаемся, что actions пустой
      } finally {
        setLoading(false);
        console.log("✅ Загрузка завершена");
      }
    };

    fetchActions();
  }, [moduleKey]);

  if (loading) {
    return <div>Загрузка...</div>;
  }

  // Определяем, какое действие показать
  let actionToShow = null;

  if (actions.length > 0) {
    // Если есть действия из API, используем первое
    actionToShow = actions[0];
    console.log("✅ Используем действие из API:", actionToShow);
  } else if (defaultActions[moduleKey]) {
    // Если нет действий из API, используем дефолтное
    actionToShow = defaultActions[moduleKey];
  } else {
    // Если нет ни API действий, ни дефолтных - не показываем кнопку
    console.warn("❌ Нет действий для модуля:", moduleKey);
    return null;
  }
  // Отображаем кнопку
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: "10px",
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={
          onAddClick || (() => console.log(`Действие: ${actionToShow.label}`))
        }
        sx={{
          borderRadius: "20px",
          padding: "10px 20px",
          textTransform: "none",
        }}
      >
        {actionToShow.label}
      </Button>
    </Box>
  );
};

export default AddButton;
